import store from "store2"; //storing browser data
import { dashToCamelCase } from "../../shared/helpers";
//sets session data
//local storage does not expire when page(session) is closed, while session storage will expire when page is closed

export const initStoreAlpaca = () => {
  if (store.session.has("initialized") && store.local("initialized")) {
    return store.session;
  }

  //changes the character based on the lab
  store.session.set("displayImage", "tiger");
  if (store.session.get("config").labId === "numberLab") {
    store.session.set(
      "displayImage",
      dashToCamelCase(store.session.get("config").taskName + "-display"),
    );
  }

  // clear any timers if they exist in the browser
  if (store.session("timerId")) {
    clearTimeout(store.session.get("timerId"));
  }
  if (store.session("timerIdCountdown")) {
    clearTimeout(store.session.get("timerIdCountdown"));
  }
  store.session.set("timerId", null);
  store.session.set("timerIdCountdown", null);
  store.session.set("intervalId", null);

  //allows for keypress for the next trial without keyup occuring first if time out occurs
  store.session.set("allowKeyUp", false);

  // warning message for double response items
  store.session.set("warningVisible", false);

  // for storing next stimulus
  store.session.set("nextStimulus", null);

  store.session.set("dataCorrect", 0); // intialise data correct variable, gets updated in stimulusNumber.js
  store.session.set("totalCorrect", 0); //overall correct
  store.session.set("trialNumTotal", 0); // counter for trials in experiment

  store.session.set("timeOut", false); // initialise the time out variable, gets updated in stimulusNumber.js
  store.session.set("countDownStarted", false);

  store.session.set("timerForceQuit", 30000);
  store.session.set("timeForceOut", false);

  // working copy of the three corpuses (items are removed as they are used)
  store.session.set("currentCorpus", ""); //initialise current corpus as empty string, gets updated in stimulusNumber.js

  // index for keeping track of trials for timer
  store.session.set("indexTracking", -1); //gets updated in stimulusNumber.js
  store.session.set("practiceIndex", 0);

  // this should be the last set before return
  store.session.set("initialized", true);

  return store.session;
};
